import * as Preact from 'preact';
import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

import { styled } from '@mui/material';

/** Basic MUI loading button but with our specific styling */
export const Component = styled(LoadingButton)<LoadingButtonProps>({
    borderRadius: '8px',
    textTransform: 'none',
    '&.MuiButton-outlinedSecondary': {
        border: '1px solid #E0E0E0',
        '&:hover': {
            border: '1px solid #BDBDBD',
        },
    },
    '&.MuiButton-sizeSmall': {
        fontSize: '0.6875rem',
        fontWeight: 500,
        lineHeight: '1.375rem',
    },
    '&.MuiButton-sizeMedium': {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '1.5rem',
    },
    '&.MuiButton-sizeLarge': {
        fontSize: '0.9375rem',
        fontWeight: 500,
        lineHeight: '1.625rem',
    },
});
